import { render, staticRenderFns } from "./LayoutView.vue?vue&type=template&id=65bb713b&scoped=true&"
import script from "./LayoutView.vue?vue&type=script&lang=js&"
export * from "./LayoutView.vue?vue&type=script&lang=js&"
import style0 from "./LayoutView.vue?vue&type=style&index=0&id=65bb713b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb713b",
  null
  
)

export default component.exports